import { Stack, Title } from '@mantine/core'
import { ReferralLetterTab } from '@/pages/website/index'

export default function ReferralLetterPage() {
  return (
    <Stack>
      <Title order={2}>Илгээх бичиг</Title>
      <ReferralLetterTab />
    </Stack>
  )
}
